import { gql } from '@apollo/client';

export const GET_DECISION_TREES_LIST = gql`
  query DecisionTrees($params: FindDecisionTreeListInput!) {
    decisionTrees(params: $params) {
      success
      message
      errors
      data {
        trees {
          id
          treeKey
          name
          description
          icon
          displayOrder
          isActive
          createdAt
          createdBy
          updatedAt
          updatedBy
        }
        hasMorePages
        nextPage
        totalPages
        totalRecords
      }
    }
  }
`;

export const GET_DECISION_TREE = gql`
  query DecisionTree($params: FindDecisionTreeInput!) {
    decisionTree(params: $params) {
      success
      message
      errors
      data {
        id
        treeKey
        name
        description
        icon
        displayOrder
        isActive
        createdAt
        createdBy
        updatedAt
        updatedBy
      }
    }
  }
`;
